module.exports = __webpack_public_path__ + "img/360-matsal.cd03e7f0.jpg";